import React, { createContext, useContext, useState } from "react";
import { ISubHeadingContext, ISubHeadingData } from "../exports/interfaces";

const SubHeadingContext = createContext<ISubHeadingContext>({
  subHeadingData: [],
  setSubHeadingData: () => null,
});
export const useSubHeadingContext = () => useContext(SubHeadingContext);

export const SubHeadingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [subHeadingData, setSubHeadingData] = useState<ISubHeadingData[]>([]);

  return (
    <SubHeadingContext.Provider value={{ subHeadingData, setSubHeadingData }}>
      {children}
    </SubHeadingContext.Provider>
  );
};